import type { WidgetPreset } from "../types";
import templateHtml from "./template.html?raw";

export const LIGHT_BULB: WidgetPreset = {
  id: "lightbulb",
  label: "Light Bulb 💡",
  defaultWidth: 128,
  defaultHeight: 168,
  html: templateHtml,
};
